import { differenceInHours, isEqual, startOfDay } from 'date-fns';

export const isAllDayEvent = (startDate: Date, endDate: Date): boolean => {
  const isStartDateStartOfDay = isEqual(startOfDay(startDate), startDate);
  if (isStartDateStartOfDay && differenceInHours(endDate, startDate) === 24) {
    return true;
  }
  return false;
};
